import { render, staticRenderFns } from "./CreateDomain.vue?vue&type=template&id=3a4c31e0&"
import script from "./CreateDomain.vue?vue&type=script&lang=js&"
export * from "./CreateDomain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports